import React from 'react';

import RequiredText from './fields/required-text.js';
import OptionalText from './fields/optional-text.js';
import DropDown from './fields/drop-down.js';

export default ({
  customisations,
  changeName, changeLabel, changePrice, deleteCustomisation,
  addNewDropDownOption, deleteDropDownOption, changeOptionValue, changeOptionPrice,
}) => {
  const custs = customisations.map((customisation) => {
    if (customisation.type === 'required_text') {
      return (
        <li key={customisation.index}>
          <RequiredText
            customisation={customisation}
            changeName={changeName}
            changeLabel={changeLabel}
            deleteCustomisation={deleteCustomisation}
          />
        </li>
      );
    } else if (customisation.type === 'optional_text') {
      return (
        <li key={customisation.index}>
          <OptionalText
            customisation={customisation}
            changeName={changeName}
            changeLabel={changeLabel}
            changePrice={changePrice}
            deleteCustomisation={deleteCustomisation}
          />
        </li>
      );
    } else if (customisation.type === 'drop_down') {
      return (
        <li key={customisation.index}>
          <DropDown
            customisation={customisation}
            changeName={changeName}
            changeLabel={changeLabel}
            deleteCustomisation={deleteCustomisation}
            addNewDropDownOption={addNewDropDownOption}
            deleteDropDownOption={deleteDropDownOption}
            changeOptionValue={changeOptionValue}
            changeOptionPrice={changeOptionPrice}
          />
        </li>
      );
    } else {
      throw new Error(`Unhandled customisation: ${JSON.stringify(customisation)}`);
    }
  });
  return <section className="Fields"><ul>{custs}</ul></section>;
};



// WEBPACK FOOTER //
// ./src/app/item-customisations/fields.js